import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { getMatterContactConnections } from "@/lib/utils/matters/matter-contact-connection-party-roles";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

/** Roles belong to the current matter, not the person's firm-wide profile. */
export function useMatterPersonRoles(matterId?: string) {
  const { data } = useQuery(retrieveMatterQueryOptions(matterId ?? ""));

  return useMemo(() => {
    const contactRoles = new Map<string, string[]>();
    const userRoles = new Map<string, string[]>();
    const addRole = (
      roles: Map<string, string[]>,
      id: string,
      label: string,
    ) => {
      const labels = roles.get(id) ?? [];
      if (label && !labels.includes(label)) {
        roles.set(id, [...labels, label]);
      }
    };

    (data?.data ? getMatterContactConnections(data.data) : []).forEach(
      (connection) => {
        if (!connection.dateTimeEnd) {
          addRole(contactRoles, connection.contactId, connection.label);
        }
      },
    );
    data?.data.assignees.forEach(({ user, role, dateTimeEnd }) => {
      if (!dateTimeEnd) {
        addRole(userRoles, user.id, role.label);
      }
    });

    return { contactRoles, userRoles };
  }, [data]);
}
